import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "absolute top-0 left-0 flex flex-col w-full h-full overflow-hidden rounded-lg gap-y-4" };
import { computed } from "vue";
import { useAbility } from "@/domains/auth";
import { useAuthStore } from "@/domains/auth";
import AdminDashboard from "./AdminDashboard.vue";
import ConciergeDashboard from "./ConciergeDashboard.vue";
import ProviderDashboard from "./ProviderDashboard.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardContent',
    setup(__props) {
        const { can } = useAbility();
        const authStore = useAuthStore();
        const dashboardContextKey = computed(() => authStore.currentOrgId ? `tenant:${authStore.currentOrgId}` : "global");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (_unref(can)('manage', 'all'))
                    ? (_openBlock(), _createBlock(AdminDashboard, {
                        key: `admin:${dashboardContextKey.value}`
                    }))
                    : (_unref(can)('read', 'Dashboard') && _unref(authStore).currentOrgType === 'concierge')
                        ? (_openBlock(), _createBlock(ConciergeDashboard, {
                            key: `concierge:${dashboardContextKey.value}`
                        }))
                        : (_unref(can)('read', 'Dashboard') && _unref(authStore).currentOrgType === 'provider')
                            ? (_openBlock(), _createBlock(ProviderDashboard, {
                                key: `provider:${dashboardContextKey.value}`
                            }))
                            : _createCommentVNode("", true)
            ]));
        };
    }
});
